/** Renders a "toast" message that is only visible to screen readers. */

import * as React from "react";

import {SchedulePolicy, useTimeout} from "@khanacademy/wonder-blocks-timing";

import ScreenReaderAlert, {
    type ScreenReaderAlertRefHandle,
} from "./screen-reader-alert.tsx";

export interface ScreenReaderToastRefHandle {
    toast: (message: string) => void;
}

function ScreenReaderToast(
    _: Empty,
    ref: React.Ref<ScreenReaderToastRefHandle>,
): React.ReactElement {
    const [message, setMessage] = React.useState<string | null>(null);
    const alertRef = React.useRef<ScreenReaderAlertRefHandle | null>(null);

    const {set: setStopToastTimeout} = useTimeout(
        () => setMessage(null),
        3000,
        {
            schedulePolicy: SchedulePolicy.OnDemand,
        },
    );

    React.useImperativeHandle(ref, () => ({
        toast: (text) => {
            setMessage(text);
            alertRef.current?.forceAlert();
            setStopToastTimeout();
        },
    }));

    return <ScreenReaderAlert ref={alertRef}>{message}</ScreenReaderAlert>;
}

export default React.forwardRef(ScreenReaderToast);
